var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "callout",
        {
          class: [_vm.studentRowColor],
          attrs: {
            "apply-border-top": "",
            controlled: true,
            "has-border": false,
            "has-gradient": "",
            "has-toggle": "",
            opened: _vm.value.isOpen
          },
          on: { "click:open": _vm.showDetail },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _vm.openAdsencePanel
                    ? _c(
                        "div",
                        {
                          staticClass: "row px-4 py-3 w-100",
                          class: _vm.isMobile && "mx-0"
                        },
                        [
                          _c("div", { staticClass: "col-12 d-flex" }, [
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-circle text-orange mr-2 mt-1",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _c(
                              "p",
                              { staticClass: "font-16 font-weight-bold" },
                              [_vm._v("Informacion de Ausencias")]
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "validation-observer",
                                { ref: "formAbsense" },
                                [
                                  _c("div", { staticClass: "row mb-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-md-4 mb-3 mb-lg-0"
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-drop-down", {
                                                      attrs: {
                                                        "custom-error-msg":
                                                          "El tipo de ausencia es requerido.",
                                                        error: errors[0],
                                                        fieldkey: "id",
                                                        fieldname: "name",
                                                        label: "Tipo:",
                                                        options:
                                                          _vm.visitTypeAusencia,
                                                        placeholder:
                                                          "Seleccione"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.modelAbsence.type,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.modelAbsence,
                                                            "type",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "modelAbsence.type"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2132149045
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-md-4 mb-3 mb-lg-0"
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _vm.showIfAusencia(
                                                      _vm.modelAbsence
                                                    )
                                                      ? _c("custom-drop-down", {
                                                          attrs: {
                                                            "custom-error-msg":
                                                              "La justificacion es requerida.",
                                                            error: errors[0],
                                                            fieldkey: "id",
                                                            fieldname: "name",
                                                            label:
                                                              "Justificacion:",
                                                            options:
                                                              _vm.justificationOptions,
                                                            placeholder:
                                                              "Seleccione"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.modelAbsence
                                                                .justification,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.modelAbsence,
                                                                "justification",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "modelAbsence.justification"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2032778616
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _vm.requiresDocumentation
                                      ? _c(
                                          "div",
                                          { staticClass: "col-12 col-md-4" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "data-name mb-2" },
                                              [
                                                _vm._v(
                                                  " Documento de Justificacion de Ausencia: "
                                                )
                                              ]
                                            ),
                                            _c("validation-provider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _vm.showIfAusencia(
                                                          _vm.modelAbsence
                                                        )
                                                          ? _c(
                                                              "custom-file-input",
                                                              {
                                                                ref:
                                                                  "attachedDocument",
                                                                attrs: {
                                                                  accept:
                                                                    ".pdf",
                                                                  "attachment-id":
                                                                    _vm
                                                                      .modelAbsence
                                                                      .documentId,
                                                                  "custom-error-msg":
                                                                    "El documento es requerido.",
                                                                  "display-style":
                                                                    "normal",
                                                                  error:
                                                                    errors[0],
                                                                  "label-position":
                                                                    "left",
                                                                  "on-download":
                                                                    _vm.onDownloadAbsenceDocument,
                                                                  required: ""
                                                                },
                                                                on: {
                                                                  "after-remove": () => {
                                                                    _vm.modelAbsence.file = null
                                                                    _vm.modelAbsence.documentId = null
                                                                  },
                                                                  input: () => {}
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .modelAbsence
                                                                      .selectedDocument,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.modelAbsence,
                                                                      "selectedDocument",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "modelAbsence.selectedDocument"
                                                                }
                                                              }
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                1616350625
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _vm.showIfAusencia(
                                                      _vm.modelAbsence
                                                    )
                                                      ? _c("custom-text-area", {
                                                          attrs: {
                                                            id:
                                                              "AbcenseComment",
                                                            "custom-error-msg":
                                                              "El comentario es requerido.",
                                                            error: errors[0],
                                                            label:
                                                              "Comentario:",
                                                            maxlength: 3000,
                                                            placeholder:
                                                              "Escriba un comentario",
                                                            "show-char-count":
                                                              ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.modelAbsence
                                                                .comment,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.modelAbsence,
                                                                "comment",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "modelAbsence.comment"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1639356661
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "row header-row" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-12",
                              attrs: { id: "detail-msg" }
                            },
                            [
                              _c("em", {
                                staticClass:
                                  "fas fa-info-circle color-orange mr-2"
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-gray-7 font-weight-bold font-14"
                                },
                                [
                                  _vm._v(
                                    " Detalle(s) del registro de la(s) visita(s) "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c("AssistanceDetailsRow", {
                            attrs: {
                              "is-mobile": _vm.isMobile,
                              "justification-options": _vm.justificationOptions,
                              "student-assistance-details": _vm.value.visits,
                              "visit-type-options": _vm.visitTypeAusencia
                            },
                            on: {
                              "download-absence-document":
                                _vm.onDownloadAbsenceDocument,
                              "edit-visit": _vm.onEditVisit,
                              "save-edition": _vm.onSaveEdition
                            }
                          })
                        ],
                        1
                      )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-md-4 align-items-center",
                class: {
                  "col-student": !_vm.isMobile,
                  "pl-1": _vm.isMobile
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "mt-4 font-14 d-flex justify-content-between"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "color-black",
                        class: {
                          "font-weight-normal": !_vm.isMobile,
                          "ml-1 font-weight-bold": _vm.isMobile
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.studentSieName) + " ")]
                    ),
                    _vm.showViewErrors
                      ? _c("div", [
                          _c("em", {
                            staticClass: "fas fa-info-circle color-orange mr-2"
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "errors-link",
                              on: { click: _vm.showErrors }
                            },
                            [_vm._v(" Ver Errores ")]
                          )
                        ])
                      : _vm._e(),
                    _c("action-button", {
                      attrs: {
                        disabled: !_vm.value.hasPlan,
                        i: "fas fa-save ml-1",
                        variant: "success"
                      },
                      on: { click: () => _vm.saveVisit(!_vm.value.hasPlan) }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                class: {
                  "d-plex py-3 row col": !_vm.isMobile,
                  "grid-7 w-100 mr-2": _vm.isMobile
                }
              },
              _vm._l(_vm.changeViewMode(), function(day) {
                return _c(
                  "div",
                  {
                    key: day,
                    class: {
                      col: !_vm.isMobile
                    }
                  },
                  [
                    _vm.showVisitScheduleUpdatedIcon(day)
                      ? _c("i", {
                          staticClass:
                            "far fa-clock mr-1 visit-schedule-updated-icon",
                          class: {
                            "text-success": _vm.visitScheduleUpdated(day)
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onClickUpdateSchedule(day)
                            }
                          }
                        })
                      : _vm._e(),
                    _c("vue-select", {
                      key: _vm.componentKey,
                      staticClass: "col col-md-2 py-2 px-1",
                      class: {
                        "select-assistence": !_vm.isMobile,
                        "vue-select__extended":
                          _vm.isMobile && _vm.getVisitType(day)
                      },
                      attrs: {
                        clearable: false,
                        disabled: _vm.disableDay(day) || !_vm.value.hasPlan,
                        options: _vm.assistenceType,
                        searchable: false,
                        value: _vm.getVisitType(day)
                      },
                      on: {
                        input: function($event) {
                          return _vm.setVisitType(day, $event)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selected-option",
                            fn: function({ label }) {
                              return [
                                _vm.getAssistenceTypeItem(label).img
                                  ? _c("img", {
                                      class: {
                                        "ml-3": _vm.showVisitScheduleUpdatedIcon(
                                          day
                                        )
                                      },
                                      attrs: {
                                        src: _vm.getAssistenceTypeItem(label)
                                          .img
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "option",
                            fn: function({ label, img }) {
                              return [
                                img
                                  ? _c("img", { attrs: { src: img } })
                                  : _vm._e(),
                                _vm._v(" " + _vm._s(label) + " ")
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm.showVisitScheduleUpdatedComponent(day)
                      ? _c("visit-calendar-schedule-update", {
                          attrs: {
                            data: _vm.visitScheduleSelected,
                            day: day,
                            duration: _vm.value.duration,
                            "schedule-id": _vm.getSchedule(day).id
                          },
                          on: {
                            cancel: _vm.onCancelScheduleUpdate,
                            save: _vm.onSaveScheduleUpdate
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]
      ),
      !this.value.isOpen
        ? _c(
            "div",
            _vm._l(_vm.uniqueErrors, function(error) {
              return _c(
                "div",
                { key: error.id, staticClass: "col-sm-12 visit-errors" },
                [
                  _c("div", { staticClass: "pl-1 pt-2" }, [
                    _c("em", {
                      staticClass: "fa fa-times-circle",
                      attrs: { "data-v-1b84b342": "" }
                    }),
                    _c("p", { staticClass: "text-left d-inline ml-1" }, [
                      _vm._v(_vm._s(error.message))
                    ])
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      !this.value.hasPlan ? _c("div", [_vm._m(0)]) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 visit-errors" }, [
      _c("div", { staticClass: "pl-1 pt-2" }, [
        _c("em", { staticClass: "fa fa-times-circle" }),
        _c("p", { staticClass: "text-left d-inline ml-1" }, [
          _vm._v(" No cuenta con un plan de intervención en sistema. ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }